export const appRouterBasename = process.env.APP_ROUTER_BASENAME;
